import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterHeadline} from "../../helpers/filters";
import Paragraph from "../Paragraph";

interface Data {
    paragraphById: {
        fieldHeadline: string;
        fieldCta: Array<{
            targetRevisionId: string
        }>;
        fieldObjectImgMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: number;
                    height: number;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>; }
}

class InnerFeaturedCardFullWidthQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphInnerFeaturedCardFullWidth {
          fieldCta {
            targetRevisionId
          }
          fieldHeadline
          fieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    targetId
                    alt
                    title
                  }
                }
            }
          }
        }
      }
    }
  }
}
`;

const InnerFeaturedCardFullWidth = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <InnerFeaturedCardFullWidthQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            markComponentLoadedAs(id, true);

            const backgroundImage = field && field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url ? field.fieldObjectImgMedia.entity.fieldMediaImage.url : null;

            return (
                <div className={`innerFeaturedCardFw`} style={{backgroundImage: `url('${backgroundImage}')`, '--aspect-ratio': '1.5/1'}}>
                    <div className="innerFeaturedCardFw__content">
                        {field.fieldHeadline && (
                            // eslint-disable-next-line react/no-danger
                            <h2 dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldHeadline)}} />
                        )}

                        {field.fieldCta && field.fieldCta.targetRevisionId ? (
                            <Paragraph key={`${id}_${field.fieldCta.targetRevisionId}`}
                                       id={String(field.fieldCta.targetRevisionId)}
                                       handleLoadedComponents={handleLoadedComponents}/>
                        ) : null}
                    </div>
                </div>
            );
        }}
    </InnerFeaturedCardFullWidthQuery>
);

InnerFeaturedCardFullWidth.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default InnerFeaturedCardFullWidth;



// WEBPACK FOOTER //
// ./frontend/components/FeaturedCardsFullWidth/InnerFeaturedCardFullWidth.jsx